import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
function WalletRecycleCustomer() {
    const [loading, setLoading] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [walletCode, setWalletCode] = useState([]);
    const [collect, setCollect] = useState("");
    const [staff, setStaff] = useState("");
    const [staffCode, setStaffCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ remarks: "", network: "", date: "", toDate: "" })
    const initialFormData = { remarks: "", network: "", date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/login'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
const EditClick = (id, bill_type, exe_name,date) => {
    if (!id) {
        console.error("❌ Missing ID in EditClick()");
        return;
    }

    const safeBill = (bill_type || "").toLowerCase();

    const routePath =
        safeBill === "collection"
            ? `/walletCustomerView/${id}`
            : `/newConnectionView/${id}`;

    navigate(routePath, {
        state: {
            user,
            date,
            exe_name: exe_name || ""
        }
    });
};


    const downloadCSV = () => {
        const headers = ["Sno", "Name", "Remarks", "Card Count", "Amount", "Date", "Collect", "Received Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        currentRows.forEach(row => { csvRows.push([row.id, row.exe_name, row.bill_type, row.card_count, row.amount, row.date, row.flat_name, row.rec_staff].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "Wallet.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = walletCode.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(walletCode.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
    const handleDelete = async (id) => {
        console.log(`Deleting group with ID: ${id}`);
        try {
            const response = await axios.post(`https://node.cabletvpay.in/Recyclewalletdelete`, { user, id });
            if (response.status === 200) {
                toast.success("Staff deleted successfully.");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error deleting staff");
        }
    };
    async function handleSaveCollectionStaff(e){
        e.preventDefault();
        try{
            console.log(user,staff,collect);
            
            const response = await axios.post('https://node.cabletvpay.in/walletSaveCollectionStaff', {user,staff,collect});
            if(response.status === 200) {
                toast.success("Successfully Updated");
                 setTimeout(() => {
                    window.location.reload(); 
                });
                        }
                    } catch(error){
                        console.log(error);
                        toast.error("error occured at saving staff amount")
                    }
                }
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); handleWallet();
        async function handleWallet() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/walletRecycleSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data);

                    setWalletCode(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    } 
async function handleRecover(id) {
  try {
    const response = await axios.post(
      "https://node.cabletvpay.in/handleWalletRecover",
      { user, id }
    );

    if (response.status === 200) {
      toast.success("Customer Recover Successfully");

      setTimeout(() => {
        navigate("/walletamount"); // ✅ redirect here
      }, 1000);
    }
  } catch (error) {
    console.log(error.response?.data?.message || "Error fetching data");
    toast.error(error.response?.data?.message || "Error fetching data");
  }
}
 const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/walletRecycleGetInfo', { user });
            if (response.status === 200) {
                console.log(response.data);

                setStaffCode(response.data.staffCode);
                setWalletCode(response.data.walletCode);

            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);

    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
            <img src="../asset/img/errorPage.jpg" alt="" style={{ height: "20rem" }} />
        </div></div>);
    return (

        <div className="content-wrapper">
            <div className="content-header pt-1">
                <h5 className='h5'>PAID CUSTOMER DETAILS</h5><hr className='mt-0' />
                <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                <div className="border-0 px-1">
                    <form method="get" onSubmit={handleSubmit}>
                        <div className="row mx-3  d-flex justify-content-center">
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="remarks" className="text-center valuesDec text-navy">Remarks Type</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="remarks" name="remarks" value={formData.remarks} onChange={handleChange}>
                                        <option value='all'>All</option>
                                        <option value='collection'>Collection</option>
                                        <option value='new_connection'>New Connection</option>
                                        <option value='replace'>Replace Box</option>
                                        <option value='shift_connection'>Shifting Connection</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="network" className="text-center valuesDec text-navy">Staff Name</label>
                                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="network" name="network" value={formData.network} onChange={handleChange}>
                                        <option className='bg-light' value="none">none</option>
                                        {staffCode.length > 0 ? (staffCode.map((row, index) => (
                                            <option className='bg-light' key={index} value={row.name}>
                                                {row.name}
                                            </option>
                                        ))) : (<option className='bg-light' value="">No staff codes available</option>)}
                                    </select>
                                </div></div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="date" className="text-center valuesDec text-navy">Date</label>
                                    <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-12 mb-2">
                                <div className="form-group">
                                    <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                    <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-6 mb-2 d-flex justify-content-center">
                                <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                            </div>
                            <div className="col-lg-1 col-md-3 col-6 mb-2 d-flex justify-content-center">
                                <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                            </div>
                                  
                        </div>
                    </form></div>
                <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true" style={{backdropFilter:"blur(5px)"}}>
                    <div className="modal-dialog modal-dialog-centered ">
                        <div className="modal-content">
                            <div className="modal-header border bg-gradient-navy">
                                <h5 className="modal-title text-bold text-white" id="staticBackdropLabel">Card Collection Details</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" className='text-light h2' onChange={(e)=>{ e.preventDefault();setCollect("");setStaff("") }} >×</span>
                                </button>
                            </div>
                            <div className="modal-body bg-white">
                                <label htmlFor="name">Collected From :</label>
                                <input
                                    id='name'
                                    type="text"
                                    className="form-control text-navy"
                                    placeholder="Enter collected staff..." 
                                    onChange={(e)=>{ e.preventDefault();setStaff(e.target.value);}}
                                    style={{
                                        width: "100%",
                                        padding: "12px",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        border: "1px solid rgba(230, 230, 230, 0.36)",
                                        borderRadius: "8px",
                                        background: "white",
                                        transition: "all 0.3s ease-in-out",
                                        outline: "none",
                                        boxShadow: "0 4px 10px rgba(78, 78, 78, 0.36)",
                                    }}
                                />


                            </div>
                            <div className="modal-footer bg-white">
                                <button type="button" className="btn btn-dark" data-dismiss="modal" onChange={(e)=>{ e.preventDefault();setCollect("");setStaff("") }} >cancel</button>
                                <button type="button" className="btn bg-olive" onClick={handleSaveCollectionStaff}>save changes</button>
                            </div>
                        </div>
                    </div>
                </div>

               <div className="px-lg-2 px-1">
               <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Wallet Report</h4>
                                </div>
                            </div>
                              <div className="col-lg-8 mt-1">
                                <span><div className="row w-auto">
                                    <div className="col-11 col-lg-6">
                                        <div className="input-group">
                                            <input type="text" className="form-control text-navy bg-light border-0 px-1 py-0" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                            <span className="input-group-text bg-light text-navy border-0 px-2" id="basic-addon1" style={{ borderRadius: "0 5px 5px 0" }} > <i className="fas fa-search" /> </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                        <div className="d-flex justify-content-end">
                                            <div className=" btn-group">
                                                <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3 px-5 my-1 d-flex"><i className="fas fa-download pt-1 px-1" /> Download</button>
                                             
                                            </div>
                                        </div>
                                    </div>
                                </div></span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-striped table table-striped bg-white table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No</th>
                                    <th>Name</th>
                                    <th>Remarks</th>
                                    <th>Card Count</th>
                                    <th>Customers</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                    <th>Collect</th>
                                    <th>Received Staff</th>
                                     <th>Recover</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} className='text-dark'>
                                            <td className='tableText border-light'>{index + 1}</td>

                                            <td className='tableText border-light'>{row.exe_name}</td>
                                            <td className='tableText border-light'>{row.bill_type}</td>
                                            <td className='tableText border-light'>{row.card_count}</td>
                                           <td onClick={() => EditClick(row.id, row.bill_type,row.exe_name,row.date)}>
    <div className="d-flex justify-content-center">
        <button className="btn btn-info"> View</button>
    </div>
</td>

                                            <td className='tableText border-light'>{row.amount}</td>
                                            <td className='tableText border-light'>{row.date}</td>
                                            <td className='tableText border-light'><div className="d-flex justify-content-center border-0">{row.status === 1 ? (
                                                <button className="btn btn-outline-info" data-toggle="modal" data-target="#staticBackdrop" onClick={()=>{ setCollect(row.id) }}><i className="fas fa-eye"></i></button>
                                            ) : <span className='text-success mt-2 text-bold border-0'>Collected</span>}

                                            </div></td>
                                            <td className='tableText border-light'>{row.rec_staff}</td>
 <td><button className='btn btn-outline-primary' onClick={() => { handleRecover(row.id) }} ><i className="fas fa-sync" /></button></td>
                                                <td><button className='btn btn-outline-danger' onClick={() => { handleDelete(row.id) }} ><i className="fas fa-trash-alt" /></button></td>
                                        </tr>
                                    ))) : (<tr><td colSpan="10">No results found</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
            <div className="d-flex justify-content-end">
              <div className="pagination btn-group border-light">
                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                {currentPage > 3 && <span className="mx-1">...</span>}
                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                  .filter((page) => page > 1 && page < totalPages)
                  .map((page) => (
                    <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                  ))}
                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                {totalPages > 1 && (
                  <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                )}
                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
              </div>
            </div>
          </div>
                </div>
               </div>
                
            </div>
        </div>
    );
}
export default WalletRecycleCustomer;
